import React from 'react'
import { Text, Flex } from 'theme-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import recurringEventDaysReducer from '../EventFunctions/recurringEventDaysReducer'

export default function EventDays({ eventDays, variantName }) {
  let typeOfEvent = recurringEventDaysReducer(eventDays)

  return (
    <Flex variant={`${variantName}.eventDaysContainer`} className="eventDaysContainer">
      <FontAwesomeIcon style={{ marginRight: '10px', fontSize: '22px' }} icon={faCalendarAlt} />
      <Text variant={`${variantName}.eventDays`} as="span" className="eventDays">
        {typeOfEvent}
      </Text>
    </Flex>
  )
}
